export default {
    empty: 'zt-seats-map__leaflet__map__row__seat--empty',
    selected: 'zt-seats-map__leaflet__map__row__seat--selected',
    hover: 'zt-seats-map__leaflet__map__row__seat--hover',
    error: 'zt-seats-map__leaflet__map__row__seat--error'
};